if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
        };
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.closeSelector.bind(this));
        if (this.elements.button) {
          this.elements.button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.openSelector();
          });
        }

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        if (this.elements.button) {
          this.elements.button.setAttribute('aria-expanded', 'false');
        }
        if (this.elements.panel) {
          this.elements.panel.setAttribute('hidden', true);
          this.elements.panel.style.cssText = '';
        }
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }
        document.body.classList.remove('overflow-hidden-mobile', 'header-language-open');
        this.unbindHeaderLanguageReposition();
        this.restoreHeaderLanguagePanel();
        this.setMenuDrawerCountrySelectorOpen(false);
        document.removeEventListener('click', this.onOutsideClick);
        this.header.preventHide = false;
      }

      isHeaderLanguageForm() {
        return this.classList.contains('header-language-form');
      }

      usesMobileHeaderLanguagePicker() {
        return this.isHeaderLanguageForm() && window.matchMedia('(max-width: 989px)').matches;
      }

      usesMenuDrawerCountrySelector() {
        return Boolean(
          this.elements.panel?.classList.contains('country-selector') &&
            this.closest('.menu-drawer__localization, .menu-drawer')
        );
      }

      getHeaderMenuDrawer() {
        return document.querySelector('#Details-menu-drawer-container .menu-drawer');
      }

      setMenuDrawerCountrySelectorOpen(isOpen) {
        if (!this.usesMenuDrawerCountrySelector()) return;

        this.getHeaderMenuDrawer()?.classList.toggle('country-selector-open', isOpen);
      }

      forceCloseMenuDrawer() {
        const details = document.querySelector('#Details-menu-drawer-container');
        if (!details?.hasAttribute('open')) return;

        const headerDrawer = document.querySelector('header-drawer');

        details.querySelectorAll('.lace-mega-menu .mega-menu[open]').forEach((menu) => {
          menu.removeAttribute('open');
          menu.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        });
        details.querySelectorAll('details').forEach((nestedDetails) => {
          if (nestedDetails === details) return;
          nestedDetails.removeAttribute('open');
          nestedDetails.classList.remove('menu-opening');
          nestedDetails.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        });
        details.querySelectorAll('.submenu-open').forEach((node) => node.classList.remove('submenu-open'));

        details.classList.remove('menu-opening');
        details.removeAttribute('open');
        details.querySelector('summary')?.setAttribute('aria-expanded', 'false');

        document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-desktop', 'overflow-hidden-mobile');
        document.querySelector('.section-header')?.classList.remove('menu-open');

        if (headerDrawer?.onResize) {
          window.removeEventListener('resize', headerDrawer.onResize);
        }
      }

      closeDesktopMegaMenus() {
        document.querySelectorAll('.header__desktop-mega .mega-menu[open]').forEach((menu) => {
          menu.removeAttribute('open');
          menu.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        });
        document.body.classList.remove('lace-mega-menu-open');
      }

      positionHeaderLanguagePanel() {
        if (!this.isHeaderLanguageForm() || !this.elements.panel || !this.elements.button) return;

        const rect = this.elements.button.getBoundingClientRect();
        const panel = this.elements.panel;
        const isMobile = this.usesMobileHeaderLanguagePicker();

        panel.style.position = 'fixed';
        panel.style.zIndex = '10001';

        if (isMobile) {
          panel.style.left = '50%';
          panel.style.right = 'auto';
          panel.style.bottom = '2rem';
          panel.style.top = 'auto';
          panel.style.transform = 'translateX(-50%)';
          panel.style.width = 'min(32rem, calc(100vw - 3rem))';
          panel.style.minWidth = '';
        } else {
          panel.style.left = 'auto';
          panel.style.right = `${Math.max(16, window.innerWidth - rect.right)}px`;
          panel.style.top = `${rect.bottom}px`;
          panel.style.bottom = 'auto';
          panel.style.transform = 'none';
          panel.style.width = 'auto';
          panel.style.minWidth = '200px';
        }
      }

      bindHeaderLanguageReposition() {
        if (this.repositionHandler) return;

        this.repositionHandler = () => {
          if (!this.isHeaderLanguageForm() || this.elements.panel?.hasAttribute('hidden')) return;
          this.positionHeaderLanguagePanel();
        };

        window.addEventListener('resize', this.repositionHandler);
        window.addEventListener('scroll', this.repositionHandler, { passive: true });
      }

      unbindHeaderLanguageReposition() {
        if (!this.repositionHandler) return;

        window.removeEventListener('resize', this.repositionHandler);
        window.removeEventListener('scroll', this.repositionHandler);
        this.repositionHandler = null;
      }

      portalHeaderLanguagePanel() {
        if (!this.isHeaderLanguageForm() || !this.elements.panel) return;

        if (this.elements.panel.dataset.portaled !== 'true') {
          this.panelParent = this.elements.panel.parentNode;
          this.panelAnchor = this.elements.panel.nextElementSibling;
          this.elements.panel.dataset.portaled = 'true';
          document.body.appendChild(this.elements.panel);
        }

        this.positionHeaderLanguagePanel();
        this.bindHeaderLanguageReposition();
      }

      restoreHeaderLanguagePanel() {
        if (!this.elements.panel || this.elements.panel.dataset.portaled !== 'true') return;

        this.elements.panel.dataset.portaled = 'false';
        if (!this.panelParent) return;

        if (this.panelAnchor) {
          this.panelParent.insertBefore(this.elements.panel, this.panelAnchor);
        } else {
          this.panelParent.appendChild(this.elements.panel);
        }
      }

      containsLanguageControl(node) {
        return Boolean(node && (this.contains(node) || this.elements.panel?.contains(node)));
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (!this.elements.button || this.elements.button.getAttribute('aria-expanded') == 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
            if (!this.elements.button || this.elements.button.getAttribute('aria-expanded') == 'true') return;
            this.openSelector();
            break;
        }
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        if (!this.elements.button || !this.elements.panel) return;

        const isOpening = this.elements.panel.hasAttribute('hidden');
        if (!isOpening) {
          this.hidePanel();
          return;
        }

        if (this.isHeaderLanguageForm()) {
          this.forceCloseMenuDrawer();
          this.closeDesktopMegaMenus();
        }

        this.elements.button.focus();
        this.elements.panel.removeAttribute('hidden');
        this.elements.button.setAttribute('aria-expanded', 'true');

        if (this.isHeaderLanguageForm()) {
          this.portalHeaderLanguagePanel();
          if (this.usesMobileHeaderLanguagePicker()) {
            document.body.classList.add('header-language-open');
          }
        } else if (!document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile');
        }

        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.hasAttribute('data-prevent-hide')) {
          this.header.preventHide = true;
        }
        this.setMenuDrawerCountrySelectorOpen(true);

        if (this.isHeaderLanguageForm()) {
          this.onOutsideClick = this.onOutsideClick || this.handleOutsideClick.bind(this);
          setTimeout(() => document.addEventListener('click', this.onOutsideClick));
        }
      }

      handleOutsideClick(event) {
        if (this.containsLanguageControl(event.target)) return;
        this.hidePanel();
      }

      closeSelector(event) {
        if (event.target.classList.contains('country-selector__overlay')) {
          this.hidePanel();
          return;
        }

        if (!this.containsLanguageControl(event.target) || !this.containsLanguageControl(event.relatedTarget)) {
          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        let visibleCountries = allCountries.length;

        this.elements.resetButton.classList.toggle('hidden', !searchValue);

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', searchValue);
        }

        allCountries.forEach((item) => {
          const countryName = this.normalizeString(item.querySelector('.country').textContent);
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove('hidden');
            visibleCountries++;
          } else {
            item.parentElement.classList.add('hidden');
            visibleCountries--;
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries
          );
        }

        this.querySelector('.country-selector').scrollTop = 0;
        this.querySelector('.country-selector__list').scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }
    }
  );
}
